import { UTM_PARAMS } from '@/constants/constants';
import { getBaseUrl } from '@/general/helpers/getBaseUrl';

const stripUtmParams = (redirectUrl: string, baseUrl: string): string => {
  const url = new URL(redirectUrl, baseUrl);

  // Strip URL params from the redirect URL
  for (const param of UTM_PARAMS) {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
    }
  }

  return url.toString();
};

export const getSigninUrl = (redirectUrl: string = '') => {
  const baseUrl = getBaseUrl();
  const url = new URL('/api/auth/signin', baseUrl);
  if (redirectUrl) {
    url.searchParams.set('redirectUrl', stripUtmParams(redirectUrl, baseUrl));
  }

  return url.toString();
};
